import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import circleCheck from 'assets/images/circle-check.svg';
import { Color } from 'core';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { autohide } from 'utils/animations';
import useStore from 'zstore';

const CloseBox = styled.span`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: ${Color.lightGray};
  font-size: 1.5em;
  cursor: pointer;
`;

const ToastWrapper = styled.div<{ $delay: number }>`
  width: max-content;
  min-width: 400px;
  max-width: 600px;
  min-height: 48px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 8px 50px 8px 10px;
  box-shadow: 0 2.5px 5px 0 rgba(0, 0, 0, 0.5);
  color: ${Color.lightGray};
  background-color: ${Color.primaryBlack};
  position: absolute;
  text-align: left;
  bottom: 40px;
  left: 240px;
  z-index: 11;
  animation-name: ${autohide};
  animation-duration: 0.01s;
  animation-delay: ${(props) => props.$delay}s;
  animation-fill-mode: forwards;
`;

const CircleCheck = styled.img`
  padding: 0px 10px;
  color: ${Color.successGreen};
  height: 25px;
  width: 25px;
  vertical-align: middle;
`;

const ToastLink = styled.a`
  color: ${Color.lightSkyBlue};
  text-decoration: underline;
`;

const Toast = () => {
  const text = useStore((state) => state.toast);
  const isErrorToast = useStore((state) => state.isErrorToast);
  const toastLink = useStore((state) => state.toastLink);
  const toastDuration = useStore((state) => state.toastDuration);
  const removeToast = useStore((state) => state.clearToast);

  return (
    <>
      {text && (
        <ToastWrapper $delay={toastDuration} onAnimationEnd={removeToast}>
          <CloseBox onClick={removeToast}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseBox>
          {isErrorToast ? (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ padding: '0px 10px', color: Color.redText, fontSize: '25px', verticalAlign: 'middle' }}
            />
          ) : (
            <CircleCheck src={circleCheck} />
          )}
          {text}
          {toastLink && (
            <>
              {' — '}
              {toastLink.target === '_blank' ? (
                <ToastLink href={toastLink.href} target="_blank" rel="noopener noreferrer">
                  {toastLink.label}
                </ToastLink>
              ) : (
                <ToastLink as={Link} to={toastLink.href}>
                  {toastLink.label}
                </ToastLink>
              )}
            </>
          )}
        </ToastWrapper>
      )}
    </>
  );
};

export default Toast;
